/**
 * @file Browser environment detection.
 */

/**
 * Returns `true` when running in a real browser. Returns `false` for SSR,
 * Node test runners, and jsdom.
 * @returns Whether the code is executing in a real browser environment.
 */
export function isBrowser(): boolean {
  return (
    typeof document !== 'undefined' &&
    typeof window !== 'undefined' &&
    typeof navigator !== 'undefined' &&
    !/jsdom|node/i.test(navigator.userAgent)
  );
}
